import React, { useEffect } from "react";
import { CRMRoadblocksBlock } from "../../components/CRMRoadblock/CRMRoadblocksBlock/CRMRoadblocksBlock";
import { pipe } from "fp-ts/lib/function";
import { option } from "fp-ts";
import { TBlockContainerStateProps } from "../../state/TBlockContainerStateProps";
import { getRouteBlockData } from "../../state/router/getRouteBlockData";
import { simpleFold } from "../../../../shared/src/utilsByDomain/option/simpleFold";
import { updateRouteWithBlockChange } from "../../state/router/updateRouteWithBlockChange";
import { TRoadblockEvidenceLink } from "../../../../domain/codecs/form/RoadblockForm";


const CRMCaseRoadblocksContainer = (props: TBlockContainerStateProps): JSX.Element => {

    const blockData = pipe(
        getRouteBlockData(props.state.routes),
        simpleFold
    );
    const openRoadblockID = blockData?.blocksOpened[props.index].meta["openRoadblockID"];
    const openRoadblockView = blockData?.blocksOpened[props.index].meta["openRoadblockView"];

    useEffect(
        () => props.dispatch({
            type: "LEGAL_CASE_GET_ROADBLOCKS",
            payload: null
        }), 
        []
    );

    const onOpenEvidenceLink = (link: TRoadblockEvidenceLink) => {
        const section = link.section;
        const routeAction =
            section !== null
                ? link.block === "case_contracts"
                    ? updateRouteWithBlockChange("case_contracts", 0, (block) => ({ ...block, meta: { visible_sections: section } }))(props.state.routes)
                    : updateRouteWithBlockChange("case_details", 0, (block) => ({ ...block, meta: { visible_sections: section } }))(props.state.routes)
                : link.block === "case_title_checks" ? updateRouteWithBlockChange("case_title_checks", 0)(props.state.routes)
                : link.block === "charges_and_restrictions" ? updateRouteWithBlockChange("charges_and_restrictions", 0)(props.state.routes)
                : link.block === "case_contracts" ? updateRouteWithBlockChange("case_contracts", 0)(props.state.routes)
                : link.block === "case_quotes" ? updateRouteWithBlockChange("case_quotes", 0)(props.state.routes)
                : updateRouteWithBlockChange("case_details", 0)(props.state.routes);

        pipe(
            routeAction,
            option.fold(
                () => undefined,
                (action) => props.dispatch(action),
            ),
        );
    };

    const updateRoutesBlockParamsToCacheOpenBlocksID = (openRoadblockID?: string) => {
        pipe(
            props.state.routes,
            updateRouteWithBlockChange(
                "case_roadblocks", 
                props.index,
                (blockParams) => ({
                    ...blockParams,
                    meta: { openRoadblockID }
                })
            ),
            option.fold(
                () => undefined,
                (routeAction) => props.dispatch(routeAction)
            )
        )
    }

    return (
        <CRMRoadblocksBlock
            sessionUser={props.state.global.user}
            openRoadblockID={openRoadblockID}
            openRoadblockView={openRoadblockView}
            roadblocksForm={props.state.forms.case_roadblocks_block}
            onOpen={(item) => {
                updateRoutesBlockParamsToCacheOpenBlocksID(item.id);
                props.dispatch({
                    type: "LEGAL_CASE_GET_ROADBLOCK",
                    payload: item.detailed_roadblock_form
                });
            }}
            onClose={() => {
                updateRoutesBlockParamsToCacheOpenBlocksID();
                props.dispatch({
                    type: "LEGAL_CASE_GET_ROADBLOCKS",
                    payload: null
                });
            }}
            onRefresh={(payload) => props.dispatch({
                type: "LEGAL_CASE_REFRESH_ROADBLOCK",
                payload
            })}
            onChange={(payload) => props.dispatch({
                type: "LEGAL_CASE_ROADBLOCK_CHANGE",
                payload
            })}
            onChangeManualItem={(payload) => props.dispatch({
                type: "LEGAL_CASE_UPDATE_ROADBLOCK_MANUAL_CHECK_LIST_ITEM",
                payload
            })}
            onTypeMessage={(payload) => props.dispatch({
                type: "LEGAL_CASE_TYPE_CHAT_MESSAGE",
                payload
            })}
            onSubmitMessage={(payload) => props.dispatch({
                type: "LEGAL_CASE_SUBMIT_CHAT_MESSAGE",
                payload
            })}
            onOpenForm={(payload) => props.dispatch({
                type: "BLOCK_OPEN_BEGIN_CHOICE",
                payload
            })}
            onOpenEvidenceLink={onOpenEvidenceLink}
            onSignOff={(payload) => props.dispatch({
                type: "LEGAL_CSAE_ROADBLOCK_SIGN_OFF",
                payload
            })}
            onAssign={(payload) => props.dispatch({
                type: "LEGAL_CASE_ROADBLOCK_ASSIGN",
                payload
            })}
            onAwait={(payload) => props.dispatch({
                type: "LEGAL_CASE_ROADBLOCK_AWAIT",
                payload
            })}
            onCancelAwait={(payload) => props.dispatch({
                type: "LEGAL_CASE_ROADBLOCK_CANCEL_AWAIT",
                payload
            })}
        />
    );
}
export default CRMCaseRoadblocksContainer;
